import { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";
import { Location } from "@App/Pages/Common/Location";
import { useServiceFunnel } from "@App/hooks/useServiceFunnel";

/**
 * The funnel for the general catch-all "appointment" service.
 *
 * @constructor
 */
export const TrailerHitch: FunctionComponent = () => {
  const { navigateWithQuery } = useServiceFunnel("anhaengerkupplung-nachruesten");

  return (
    <Routes>
      <Route
        path={"/"}
        element={
          <Location
            headline={"Anhängerkupplung nachrüsten"}
            subheadline={"Wo suchst du eine Werkstatt?"}
            description={
              "Wir suchen nach Werkstatten in Deiner Nähe, die Anhängerkupplungen montieren können."
            }
            step={1}
            maxSteps={9}
            onSubmit={() => navigateWithQuery(`werkstaetten`)}
          />
        }
      />
    </Routes>
  );
};
